import { Record } from 'immutable';
import { UserRecord } from '../../shared/records/user-record';

export const ContactRecord = Record({
  config: {},
  isLoading: true,
  errorMessage: '',
  successMessage: '',
  authorizedUser: UserRecord(),
});
